import { render, staticRenderFns } from "./BidOnlineTenantComponent.vue?vue&type=template&id=b0ae0424"
import script from "./BidOnlineTenantComponent.vue?vue&type=script&lang=js"
export * from "./BidOnlineTenantComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports